// should be replaced with upstream package when stimulus 2 compatibility is given.
// https://github.com/rbague/stimulus-check-all/pull/7

import { Controller } from 'stimulus'

const isChecked = el => el.checked

function setChecked(el, checked, indeterminate = false) {
  el.checked = checked
  el.indeterminate = !checked && indeterminate
}

export default class extends Controller {
  static targets = [ 'all', 'checkbox', 'count' ]

  connect() {
    setTimeout(() => { this.syncAllTargetState() })
    this.element.addEventListener('change', this.changeHandler)
  }

  disconnect() {
    this.element.removeEventListener('change', this.changeHandler)
  }

  updateCount() {
    if (this.hasCountTarget) {
      this.countTarget.textContent = this.checkboxTargets.filter(el => el.checked).length
    }
  }

  changeHandler = ({ target }) => {
    this.allTarget == target ?
      this.handleAllChange() :
      this.syncAllTargetState()
    this.updateCount()
  }

  handleAllChange() {
    this.checkboxTargets.forEach(el => {
      el.checked = this.allTarget.checked
      el.indeterminate = false
    })
  }

  syncAllTargetState() {
    if (this.hasAllTarget) {
      setChecked(
        this.allTarget,
        this.checkboxTargets.every(isChecked),
        this.checkboxTargets.some(isChecked)
      )
    }
  }
}
